import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=baf580ae&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('baf580ae')) {
      api.createRecord('baf580ae', component.options)
    } else {
      api.reload('baf580ae', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=baf580ae&", function () {
      api.rerender('baf580ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2w36wPP5Uv3xG/JS/comp/ErrorMessage.vue"
export default component.exports